<gains-tray *ngIf="isOpen" [heading]="heading" [count]="waitingCount" [isEmpty]="isEmpty" [emptyMessage]="emptyMessage" [footerNote]="footerNote" (closed$)="close()">
  <gains-alert-card
    *ngFor="let alert of displayedAlerts; trackBy: trackById"
    [alert]="alert"
    [feedback]="feedbackFor(alert)"
    [canAskDeo]="canAskDeo(alert)"
    (verdictGiven$)="onVerdictGiven(alert, $event)"
    (askDeo$)="onAskDeo($event)"
  ></gains-alert-card>
</gains-tray>
